export const enTranslations = {
  // English translations
  'nav.home': 'Home',
  'nav.findPlaces': 'Find Places',
  'nav.ratePlace': 'Rate a Place',
  'nav.ratePlaces': 'Rate Places',
  'nav.login': 'Login',
  'nav.signup': 'Sign Up',
  'nav.logout': 'Logout',
  'nav.profile': 'Profile',
  'nav.admin': 'Admin',
  'nav.menu': 'Menu',
  'nav.account': 'Account',
  'nav.favorites': 'Your Favorites',
  'favorites.description': "Businesses you've saved as favorites",
  // Buttons
  'buttons.loadMore': 'Load more',
  // Pagination
  'pagination.previous': 'Previous',
  'pagination.next': 'Next',
  'pagination.goTo': 'Go to:',
  'pagination.go': 'Go',
  'pagination.of': 'of',
  'hero.title': 'Find the Best — Skip the Rest',
  'hero.subtitle': 'Find the best — avoid the worst! Vote for or discover your favorite restaurants, gyms, entertainment centers, and more, based on real customer experiences, with one simple click!',
  'cta.findPlaces': 'Find Places',
  'cta.ratePlace': 'Rate a Place',
  'howItWorks.title': 'How It Works',
  'howItWorks.step1': 'Search for a business',
  'howItWorks.step2': 'See upvotes and downvotes',
  'howItWorks.step3': 'Leave your own vote',
  'featured.title': 'Featured Places',
  // Maintenance page
  'maintenance.title': 'Site Under Maintenance',
  'maintenance.defaultMain': "We're currently making improvements and will be back online soon!",
  'maintenance.thankYou': 'Thank you for your patience',
  // Filter translations
  'filters.categories': 'Category',
  'filters.cities': 'City',
  'filters.selected': 'selected',
  // Business card translations
  'businessCard.address': '{0}',
  'businessCard.hours': '{0}',
  'businessCard.phone': '{0}',
  'businessCard.full': 'Full',
  'whyTrustUs.title': 'Why Trust Us',
  'whyTrustUs.community': '100% Community Driven',
  'whyTrustUs.realVotes': 'No fake reviews, just real votes',
  'signup.title': 'Sign up for an account',
  'signup.button': 'Join Now',
  'footer.quickLinks': 'Quick Links',
  'footer.information': 'Information',
  'footer.about': 'About',
  'footer.contact': 'Contact',
  'footer.reachOut': 'Reach Out',
  'buttons.viewDetails': 'View Details',
  'buttons.viewAll': 'View All',
  'buttons.refresh': 'Refresh',
  'buttons.viewAllPlaces': 'View All Places',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.rights': 'All Rights Reserved',
  'footer.socialNetworks': 'Social Networks',
  
  // Profile page translations
  'profile.title': 'Profile',
  'profile.accountInformation': 'Account Information',
  'profile.email': 'Email',
  'profile.firstName': 'First Name',
  'profile.lastName': 'Last Name',
  'profile.saveChanges': 'Save Changes',
  'profile.saving': 'Saving...',
  'profile.validation.nameRequired': 'First or last name must contain at least 3 letters',
  'profile.validation.nameTaken': 'This first or last name is already taken. Please choose another.',
  'profile.validation.nameReserved': 'This first or last name is reserved and cannot be used.',
  'profile.validation.nameBadWord': 'First or last name contains inappropriate words.',
  'profile.updateSuccess': 'Profile Updated',
  'profile.updateSuccessDescription': 'Your profile has been successfully updated.',
  'profile.updateError': 'Error',
  'profile.updateErrorDescription': 'Failed to update profile. Please try again.',
  'profile.accountActions': 'Account Actions',
  'profile.signOutDescription': 'If you want to sign out of your account, click the button below.',
  'profile.signOut': 'Sign Out',
  'profile.yourActivity': 'Your Activity',
  'profile.activityDescription': 'View your votes, ratings, and reviews',
  'profile.adminTools': 'Admin Tools',
  'profile.updateAdminProfiles': 'Update Admin Profiles',
  
  // Auth translations
  'auth.signIn': 'Sign In',
  'auth.signUp': 'Sign Up',
  'auth.signInWithGoogle': 'Sign in with Google',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.error': 'Error',
  'auth.success': 'Success',
  'auth.fillAllFields': 'Please fill in all fields',
  'auth.accountCreated': 'Account created successfully! Check your email for confirmation.',
  'auth.loggedIn': 'Logged in successfully!',
  'auth.failed': 'Authentication failed',
  'auth.processing': 'Processing...',
  'auth.noAccount': 'Don\'t have an account?',
  'auth.haveAccount': 'Already have an account?',
  'auth.loginDescription': 'Enter your credentials to access your account',
  'auth.signupDescription': 'Create a new account to join our community',
  'auth.forgotPassword': 'Forgot Password?',
  'auth.resetPassword': 'Reset Password',
  'auth.enterEmailForReset': 'Enter your email address and we\'ll send you a link to reset your password.',
  'auth.emailRequired': 'Email is required',
  'auth.emailNotRegistered': 'This email is not registered. Please use the email you signed up with.',
  'auth.resetEmailSent': 'Password reset email has been sent! Check your email inbox.',
  'auth.emailSent': 'Email Sent!',
  'auth.checkEmailInbox': 'Please check your email inbox and follow the instructions to reset your password.',
  'auth.close': 'Close',
  'auth.sending': 'Sending...',
  'auth.signingIn': 'Signing in...',
  'auth.signingUp': 'Signing up...',
  'auth.emailPlaceholder': 'your@email.com',
  'auth.firstNameRequired': 'First name is required',
  'auth.lastNameRequired': 'Last name is required',
  'auth.firstName': 'First Name',
  'auth.lastName': 'Last Name',
  'auth.continueWith': 'OR CONTINUE WITH',
  'auth.passwordMinLength': 'Must be at least 6 characters',
  'auth.signUpAgreement': 'By signing up, you agree to our Terms of Service and Privacy Policy.',
  'auth.signInAgreement': 'By signing in, you acknowledge that you have read and agree to our Terms of Service and Privacy Policy.',
  // Email confirmation translations
  'emailConfirmation.invalidLink': 'Invalid confirmation link',
  'emailConfirmation.error': 'Confirmation failed',
  'emailConfirmation.success': 'Email confirmed successfully!',
  'emailConfirmation.confirming': 'Confirming Email...',
  'emailConfirmation.confirmed': 'Email Confirmed',
  'emailConfirmation.failed': 'Confirmation Failed',
  'emailConfirmation.processing': 'Processing your email confirmation...',
  'emailConfirmation.redirecting': 'Redirecting to your profile in a few seconds...',
  'emailConfirmation.tryAgain': 'Please try clicking the confirmation link again.',
  // Reset password translations
  'resetPassword.invalidLink': 'Invalid or expired reset link',
  'resetPassword.passwordTooShort': 'Password must be at least 6 characters long',
  'resetPassword.passwordMismatch': 'Passwords do not match',
  'resetPassword.success': 'Password updated successfully!',
  'resetPassword.error': 'An error occurred',
  'resetPassword.verifying': 'Verifying reset link...',
  'resetPassword.invalidTitle': 'Invalid Reset Link',
  'resetPassword.backToLogin': 'Back to Login',
  'resetPassword.title': 'Set New Password',
  'resetPassword.description': 'Enter your new password below',
  'resetPassword.newPassword': 'New Password',
  'resetPassword.passwordPlaceholder': 'Enter new password',
  'resetPassword.confirmPassword': 'Confirm Password',
  'resetPassword.confirmPasswordPlaceholder': 'Confirm new password',
  'resetPassword.updating': 'Updating...',
  'resetPassword.updatePassword': 'Update Password',
  // Reviews translations
  'reviews.title': 'Reviews',
  'reviews.yourReviews': 'Your Reviews',
  'reviews.googleReviews': 'Google Reviews',
  'reviews.noReviews': 'No reviews yet',
  'reviews.showAll': 'Show all reviews',
  'reviews.writePlaceholder': 'Write a review...',
  'reviews.submit': 'Submit Review',
  'reviews.count.one': 'review',
  'reviews.count.many': 'reviews',
  'reviews.viewMore': 'View more',
  'reviews.viewLess': 'View less',
  // Activity tab translations
  'profile.upvotes': 'Upvotes',
  'profile.downvotes': 'Downvotes',
  // Loading messages
  'loading.default': 'Loading',
  'loading.favorites': 'Loading your favorites',
  'loading.profile': 'Loading profile',
  // Month abbreviations
  'months.jan': 'Jan',
  'months.feb': 'Feb',
  'months.mar': 'Mar',
  'months.apr': 'Apr',
  'months.may': 'May',
  'months.jun': 'Jun',
  'months.jul': 'Jul',
  'months.aug': 'Aug',
  'months.sep': 'Sep',
  'months.oct': 'Oct',
  'months.nov': 'Nov',
  'months.dec': 'Dec',
  // Search translations
  'search.placeholder': 'Search places...',
  'search.submit': 'Search',
  'search.byBusinessName': 'Search by business name...',
  'search.businessesFound': '{0} businesses found',
  'search.showingOf': '(showing {0} of {1})',
  'search.showingBusinesses': 'Showing {0} of {1} businesses',
  'search.loadingBusinesses': 'Loading businesses...',
  'search.searchingBusinesses': 'Searching businesses...',
  'search.loadingMoreBusinesses': 'Loading more businesses...',
  'search.nextBusinesses': 'Next 50 Businesses',
  // Business list messages
  'businesses.noResults': 'No businesses found matching the selected filters.',
  'businesses.loadError': 'Unable to load businesses. Please try refreshing the page.',
  // Rating categories translations
  'rating.service': 'Service',
  'rating.cleanliness': 'Cleanliness',
  'rating.pricing': 'Pricing',
  'rating.interior': 'Interior',
  // Business page translations
  'business.information': 'Business Information',
  'business.reviews': 'Reviews',
  'business.ratingsTitle': 'Ratings',
  'business.overallRating': 'Overall Rating',
  'business.ratingCategories': 'Rating Categories',
  'business.website': 'Website',
  'business.googleMaps': 'View on Google Maps',
  'business.placeOrder': 'Place Order',
  'business.chooseDeliveryService': 'Choose Delivery Service',
  'business.performanceComparison': 'Performance Comparison',
  'business.compareWith': 'Compare this business with the average {0} in {1}',
  'business.basedOnBusinesses': 'based on {0} businesses',
  'business.pricingNote': 'Note on Pricing',
  'business.pricingExplanation': 'A higher star rating indicates better perceived value/affordability',
  'business.cityAverage': 'City Average',
  'business.thisBusiness': 'This Business',
  // Weekdays
  'weekdays.monday': 'Monday',
  'weekdays.tuesday': 'Tuesday',
  'weekdays.wednesday': 'Wednesday',
  'weekdays.thursday': 'Thursday',
  'weekdays.friday': 'Friday',
  'weekdays.saturday': 'Saturday',
  'weekdays.sunday': 'Sunday',
  // Rating popup translations
  'rating.rateThisBusiness': 'Rate this business',
  'rating.guestNotice': 'You can rate as a guest, but signing in helps us prevent spam',
  'rating.doneRating': 'Done Rating',
  'rating.submitError': 'Failed to submit rating',
  'rating.selectCategory': 'Please rate at least one category',
  'rating.thankYou': 'Thank you for your ratings!',
  'rating.yourRating': 'Your rating',
  'rating.clickToRate': 'Click to rate',
  // Category translations for filters
  'categories.all': 'All Categories',
  'categories.restaurant': 'Restaurant',
  'categories.cafe': 'Cafe',
  'categories.bar': 'Bar',
  'categories.hotel': 'Hotel',
  'categories.shopping': 'Shopping',
  'categories.generalShopping': 'General Store',
  'categories.generalstore': 'General Store',
  'categories.entertainment': 'Entertainment',
  'categories.health': 'Health',
  'categories.beauty': 'Beauty',
  'categories.education': 'Education',
  'categories.transport': 'Transport',
  'categories.fastFood': 'Fast Food',
  'categories.gym': 'Gym',
  'categories.pub': 'Pub',
  'categories.electronicsStore': 'Electronics Store',
  'categories.wellnessCenter': 'Wellness Center',
  'categories.shoppingMall': 'Shopping Mall',
  'categories.movieTheater': 'Movie Theater',
  'categories.hamburgerRestaurant': 'Hamburger Restaurant',
  'categories.theater': 'Theater',
  'categories.puppetTheater': 'Puppet Theater',
  'categories.museum': 'Museum',
  'categories.confectioneryShop': 'Confectionery Shop',
  'categories.shawarmaRestaurant': 'Shawarma Restaurant',
  'categories.swimmingPool': 'Swimming Pool',
  'categories.bakery': 'Bakery',
  'categories.supermarket': 'Supermarket & Hypermarket',
  'categories.supermarketandhypermarket': 'Supermarket & Hypermarket',
  'categories.iceCream': 'Ice Cream',
  'categories.coffeeShop': 'Coffee Shop',
  'categories.sportsComplex': 'Sports Complex',
  'categories.clothingStore': 'Clothing Store',
  'categories.giftShop': 'Gift Shop',
  'categories.toyStore': 'Toy Store',
  'categories.market': 'Market',
  'categories.park': 'Park',
  'categories.touristAttraction': 'Tourist Attraction',
  'categories.winery': 'Winery',
  'categories.library': 'Library',
  'categories.pizza': 'Pizza',
  'categories.homeGoodsStore': 'Home Goods Store',
  'categories.buildingMaterialsStore': 'Building Materials Store',
  'categories.automobile': 'Automobile',
  'categories.parfumeandcosmetics': 'Parfume & Cosmetics',
  'categories.jewelryandaccessories': 'Jewelry & Accessories',
  'categories.bookandstationery': 'Book & Stationery',
  'categories.alcoholandbeverages': 'Alcohol & Beverages',
  'categories.furnitureandtextiles': 'Furniture & Textiles',
  'categories.lighting': 'Lighting',
  // Lowercase category keys for radar chart
  'categories.hamburgerrestaurant': 'Hamburger Restaurant',
  'categories.fastfood': 'Fast Food',
  'categories.icecream': 'Ice Cream',
  'categories.coffeeshop': 'Coffee Shop',
  'categories.electronicsstore': 'Electronics Store',
  'categories.wellnesscenter': 'Wellness Center',
  'categories.shoppingmall': 'Shopping Mall',
  'categories.movietheater': 'Movie Theater',
  'categories.confectioneryshop': 'Confectionery Shop',
  'categories.shawarmarestaurant': 'Shawarma Restaurant',
  'categories.swimmingpool': 'Swimming Pool',
  'categories.sportscomplex': 'Sports Complex',
  'categories.clothingstore': 'Clothing Store',
  'categories.giftshop': 'Gift Shop',
  'categories.toystore': 'Toy Store',
  'categories.touristattraction': 'Tourist Attraction',
  'categories.homegoodsstore': 'Home Goods Store',
  'categories.buildingmaterialsstore': 'Building Materials Store',
  'categories.puppettheater': 'Puppet Theater',
  // City translations for filters
  'cities.tbilisi': 'Tbilisi',
  'cities.batumi': 'Batumi',
  'cities.kutaisi': 'Kutaisi',
  'cities.rustavi': 'Rustavi',
  'cities.gori': 'Gori',
  'cities.zugdidi': 'Zugdidi',
  'cities.poti': 'Poti',
  'cities.telavi': 'Telavi',
  'cities.mtskheta': 'Mtskheta',
  'cities.borjomi': 'Borjomi',
  'cities.kobuleti': 'Kobuleti',
  'cities.akhaltsikhe': 'Akhaltsikhe',
  'cities.sachkhere': 'Sachkhere',
  'cities.samtredia': 'Samtredia',
  'cities.senaki': 'Senaki',
  'cities.khashuri': 'Khashuri',
  'cities.chiatura': 'Chiatura',
  'cities.kvariati': 'Kvariati',
  'cities.baghdati': 'Baghdati',
  'cities.sairme': 'Sairme',
  'cities.kaspi': 'Kaspi',
  'cities.tsalka': 'Tsalka',
  'cities.tsalenjikha': 'Tsalenjikha',
  'cities.tskaltubo': 'Tskaltubo',
  'cities.khoni': 'Khoni',
  'cities.martvili': 'Martvili',
  'cities.vani': 'Vani',
  'cities.kareli': 'Kareli',
  'cities.marneuli': 'Marneuli',
  'cities.lanchkhuti': 'Lanchkhuti',
  'cities.shekvetili': 'Shekvetili',
  'cities.chkhorotsku': 'Chkhorotsku',
  'cities.ureki': 'Ureki',
  'cities.gonio': 'Gonio',
  'cities.anaklia': 'Anaklia',
  'cities.ushguli': 'Ushguli',
  'cities.lentekhi': 'Lentekhi',
  'cities.tsageri': 'Tsageri',
  'cities.akhalkalaki': 'Akhalkalaki',
  'cities.dusheti': 'Dusheti',
  'cities.saguramo': 'Saguramo',
  'cities.tianeti': 'Tianeti',
  'cities.akhmeta': 'Akhmeta',
  'cities.sagarejo': 'Sagarejo',
  'cities.sighnaghi': 'Sighnaghi',
  'cities.kvareli': 'Kvareli',
  'cities.gurjaani': 'Gurjaani',
  'cities.lagodekhi': 'Lagodekhi',
  'cities.dedoplistskaro': 'Dedoplistskaro',
  'cities.ninotsminda': 'Ninotsminda',
  'cities.dmanisi': 'Dmanisi',
  'cities.bolnisi': 'Bolnisi',
  'cities.gardabani': 'Gardabani',
  'cities.abasha': 'Abasha',
  'cities.tkibuli': 'Tkibuli',
  'cities.bakhmaro': 'Bakhmaro',
  'cities.chokhatauri': 'Chokhatauri',
  'cities.shuakhevi': 'Shuakhevi',
  'cities.keda': 'Keda',
  'cities.khulo': 'Khulo',
  'cities.manglisi': 'Manglisi',
  // Missing cities previously without translations
  'cities.bakuriani': 'Bakuriani',
  'cities.gudauri': 'Gudauri',
  'cities.mestia': 'Mestia',
  'cities.oni': 'Oni',
  'cities.ozurgeti': 'Ozurgeti',
  'cities.stepantsminda': 'Stepantsminda',
  'cities.terjola': 'Terjola',
  'cities.zestafoni': 'Zestafoni',
  'cities.ambrolauri': 'Ambrolauri',
  'cities.natakhtari': 'Natakhtari',
  // Review translations - additional
  'reviews.pleaseEnterReview': 'Please enter a review',
  'reviews.invalidReview': 'Invalid Review',
  'reviews.onlyBadWordsError': 'Review cannot contain only inappropriate content',
  'reviews.spamContentError': 'Your review contains promotional or spam content and cannot be submitted.',
  'reviews.pleaseWait': 'Please wait',
  'reviews.rateLimitError': 'You can submit a new review after 30 seconds',
  'reviews.mustBeLoggedIn': 'You must be logged in to submit a review',
  'reviews.duplicateReview': 'Duplicate Review',
  'reviews.somethingWentWrong': 'Something went wrong.',
  'reviews.submitFailedTryAgain': 'Failed to submit review, please try again.',
  'reviews.reviewSubmitted': 'Your review has been submitted',
  'reviews.submitFailed': 'Failed to submit review',
  'reviews.spamWarning': 'Your review appears to contain a link or promotional content.',
  'reviews.badWordsOnlyWarning': 'Review cannot contain only inappropriate words.',
  'reviews.characterLimitReached': 'Maximum character limit reached',
  'reviews.submitting': 'Submitting...',
  // Page content translations
  'pages.about.title': 'About Us',
  'pages.about.welcome': 'Welcome to GoodVote.ge – your go-to platform for discovering, exploring, and reviewing the best businesses in your area.',
  'pages.about.belief': 'At GoodVote, we believe that local knowledge is powerful. Whether you\'re searching for a cozy café, a romantic restaurant, or a hidden gem in your city, our platform helps you make confident decisions based on real user feedback and verified business data.',
  'pages.about.description': 'We use Google\'s business data API to provide up-to-date information about businesses — and then give you, the community, a voice to vote, rate, review, and recommend. Our clean and intuitive interface makes it easy to browse local listings, vote, leave reviews, and even save your favorite places for later.',
  'pages.about.independence': 'GoodVote is independent and free to use, built with simplicity in mind. We don\'t charge for access and we don\'t clutter your experience with payments. Just genuine reviews, honest opinions, and useful insights from real people.',
  'pages.about.why.title': 'Why we exist:',
  'pages.about.why.point1': 'To empower users to make better choices about local services.',
  'pages.about.why.point2': 'To support local businesses by highlighting quality and transparency.',
  'pages.about.why.point3': 'To build a trustworthy space for reviews without noise or bias.',
  'pages.about.companion': 'Whether you\'re a traveler in a new city or a local exploring your neighbourhood, GoodVote.ge is your digital companion for discovering the best around you.',
  'pages.contact.title': 'Reach out',
  'pages.contact.description': 'Have questions, suggestions, or want to get in touch? We\'d love to hear from you.',
  'pages.contact.button': 'Contact',
  'pages.contact.emailLabel': 'Our email address:',
  // Updated Terms of Service translations
  'pages.terms.title': 'Terms of Service for GoodVote.ge',
  'pages.terms.effective': 'Effective Date: July 19, 2025',
  'pages.terms.welcome': 'Welcome to GoodVote.ge! By using our website, you agree to the following Terms of Service. Please read them carefully.',
  'pages.terms.use.title': '1. Use of Our Service',
  'pages.terms.use.description': 'GoodVote.ge is a platform for discovering and reviewing local businesses.',
  'pages.terms.use.point1': 'We use public APIs from Google and other sources to pull and display business data. We do not claim ownership of this data.',
  'pages.terms.use.point2': 'You may not use the website for unlawful, harmful, or abusive purposes.',
  'pages.terms.use.point3': 'You must not attempt to hack, scrape, or reverse-engineer our services.',
  'pages.terms.content.title': '2. User-Generated Content',
  'pages.terms.content.point1': 'Users may submit reviews, votes, and feedback about businesses.',
  'pages.terms.content.point2': 'You are responsible for the content you post.',
  'pages.terms.content.point3': 'We may remove content that is offensive, misleading, or violates laws or our community standards.',
  'pages.terms.account.title': '3. Account Management and Login',
  'pages.terms.account.point1': 'Some features, such as submitting reviews or saving favorites, may require you to log in.',
  'pages.terms.account.point2': 'You are responsible for the security of your account and any activity that occurs under your account.',
  'pages.terms.account.point3': 'If you choose to sign up or log in using Google, you are agreeing to allow us to use your Google profile information (name and email) to create and manage your account. You must adhere to Google\'s Terms of Service and any other policies applicable to your use of Google accounts.',
  'pages.terms.account.point4': 'You must not share your login credentials or impersonate another person.',
  'pages.terms.ip.title': '4. Intellectual Property',
  'pages.terms.ip.point1': 'All website code, design, and original content are owned by GoodVote.ge unless otherwise stated.',
  'pages.terms.ip.point2': 'Google business data, logos, and other third-party trademarks belong to their respective owners.',
  'pages.terms.thirdparty.title': '5. Third-Party Services',
  'pages.terms.thirdparty.point1': 'We use third-party services to operate our website, including Supabase for our backend and user authentication and Google APIs to display business information.',
  'pages.terms.thirdparty.point2': 'We are not responsible for the accuracy or integrity of data from these third-party services.',
  'pages.terms.thirdparty.point3': 'Your use of our service is also subject to the terms of service of our third-party providers, including the Supabase Terms of Service and the Google Terms of Service.',
  'pages.terms.liability.title': '6. Limitation of Liability',
  'pages.terms.liability.point1': 'We are not liable for any damages resulting from the use of the site.',
  'pages.terms.liability.point2': 'The service is provided "as-is" without warranties of any kind.',
  'pages.terms.changes.title': '7. Changes to Terms',
  'pages.terms.changes.point1': 'These Terms of Service may be updated occasionally. We will notify you of significant changes by posting the new terms on this page.',
  'pages.terms.changes.point2': 'Continued use of the site after any changes means you accept the updated terms.',
  'pages.terms.termination.title': '8. Termination',
  'pages.terms.termination.description': 'We reserve the right to suspend or terminate your account and access to the service at our sole discretion, without notice, for any conduct that we believe violates these Terms of Service or is harmful to other users of the service or to us, or for any other reason.',
  'pages.terms.contact.title': '9. Contact',
  'pages.terms.contact.text': 'For questions about these terms, please email us at:',
  // Updated Privacy Policy translations
  'pages.privacy.title': 'Privacy Policy for GoodVote.ge',
  'pages.privacy.effective': 'Effective Date: July 19, 2025',
  'pages.privacy.welcome': 'Welcome to GoodVote.ge! This privacy policy explains how we collect, use, and protect your information when you use our website and services.',
  'pages.privacy.collect.title': '1. Information We Collect',
  'pages.privacy.collect.intro': 'We may collect:',
  'pages.privacy.collect.point1': 'Your name and email (if you create an account or contact us).',
  'pages.privacy.collect.point2': 'IP address, browser type, device info (automatically via cookies or logs).',
  'pages.privacy.collect.point3': 'Reviews or votes you submit.',
  'pages.privacy.collect.googleTitle': '1.1. Information Collected from Google Sign-In',
  'pages.privacy.collect.googleDescription': 'If you choose to sign up or log in using your Google account, you are granting us permission to access specific information from your Google profile. The data we collect is determined by the scopes you consent to during the sign-in process. Specifically, we access and store:',
  'pages.privacy.collect.googleName': 'Your Name:',
  'pages.privacy.collect.googleNameDescription': 'From the .../auth/userinfo.profile scope, we collect your first and last name to personalize your account and display your public activity (e.g., reviews).',
  'pages.privacy.collect.googleEmail': 'Your Email Address:',
  'pages.privacy.collect.googleEmailDescription': 'From the .../auth/userinfo.email scope, we collect your primary email address. This is essential for creating your user account, authenticating you for future logins, and communicating with you about your account and our services.',
  'pages.privacy.collect.googleNote': 'We use this information to create your user account and pre-fill your profile. We do not access, store, or share any other information from your Google account, such as your contacts, calendar, or files. The openid scope is also used to verify your identity.',
  'pages.privacy.use.title': '2. How We Use Your Information',
  'pages.privacy.use.intro': 'We use your information to:',
  'pages.privacy.use.point1': 'Provide and improve our services.',
  'pages.privacy.use.point2': 'Display your reviews and ratings on business listings.',
  'pages.privacy.use.point3': 'Send notifications or updates (if you opted in).',
  'pages.privacy.use.point4': 'Analyze usage patterns to enhance user experience.',
  'pages.privacy.use.point5': 'To create and manage your account when you sign in via Google.',
  'pages.privacy.cookies.title': '3. Cookies and Tracking',
  'pages.privacy.cookies.text': 'We use cookies to improve site functionality and for analytics. You can disable cookies in your browser settings, but some features may not work properly.',
  'pages.privacy.thirdparty.title': '4. Third-Party Services',
  'pages.privacy.thirdparty.text': 'We may use third-party services to help us operate our website and services.',
  'pages.privacy.thirdparty.supabase': 'Supabase:',
  'pages.privacy.thirdparty.supabaseDescription': 'We use Supabase as our backend service provider. Your account data, including your name and email, is securely stored on their platform. By using Google Sign-In, you consent to your data being stored and processed by Supabase in accordance with their privacy policy.',
  'pages.privacy.thirdparty.analytics': 'Google Analytics:',
  'pages.privacy.thirdparty.analyticsDescription': 'We use Google Analytics to analyze website usage. This service has its own privacy policy.',
  'pages.privacy.sharing.title': '5. Data Sharing',
  'pages.privacy.sharing.intro': 'We do not sell your personal information. We may share data only in these cases:',
  'pages.privacy.sharing.point1': 'With your consent.',
  'pages.privacy.sharing.point2': 'For legal compliance or to protect our rights.',
  'pages.privacy.sharing.point3': 'With the third-party service providers listed above who help us operate the site.',
  'pages.privacy.security.title': '6. Data Security',
  'pages.privacy.security.text': 'We implement reasonable security measures to protect your data, including storing your information on secure platforms like Supabase. However, no online service can guarantee 100% security.',
  'pages.privacy.rights.title': '7. Your Rights',
  'pages.privacy.rights.description': 'You have the right to access, correct, or delete your data.',
  'pages.privacy.rights.point1': 'You can manage your profile information within your account settings.',
  'pages.privacy.rights.point2': 'To request access, correction, or deletion of your personal data, please contact us at contact@goodvote.ge.',
  'pages.privacy.rights.point3': 'You can opt out of cookies or analytics tracking through your browser settings.',
  'pages.privacy.changes.title': '8. Changes to This Policy',
  'pages.privacy.changes.text': 'This Privacy Policy may be updated from time to time. We will post updates on this page with a new effective date. We encourage you to review this policy periodically.',
  'pages.privacy.contact.title': '9. Contact',
  'pages.privacy.contact.text': 'If you have any questions about this Privacy Policy or our data practices, please contact us at:',

  // Review reactions
  'reviews.like': 'Like',
  'reviews.dislike': 'Dislike',
  'reviews.signInToReact': 'Please sign in to react to this review',
  'reviews.reactionError': 'Failed to update reaction',

  // Badges
  'badges.newbie': 'Newbie',
  'badges.explorer': 'Explorer',
  'badges.helper': 'Helper',
  'badges.trustedLocal': 'Trusted Local',
  'badges.localExpert': 'Local Expert',
  'badges.cityMaster': 'City Master',
  'badges.countryMaster': 'Country Master',
  'badges.cleanlinessGuardian': 'Cleanliness Guardian',
  'badges.priceScout': 'Price Scout',
  'badges.serviceJudge': 'Service Judge',
  'badges.interiorCritic': 'Interior Critic',

  // Badge descriptions
  'badges.desc.newbie': '1 to 9 reviews/ratings',
  'badges.desc.explorer': '10 to 29 reviews/ratings',
  'badges.desc.helper': '30 to 49 reviews/ratings',
  'badges.desc.trustedLocal': '50 to 99 reviews/ratings',
  'badges.desc.localExpert': '100 to 199 reviews/ratings',
  'badges.desc.cityMaster': '200 to 299 reviews/ratings',
  'badges.desc.countryMaster': '300+ reviews/ratings',
  'badges.desc.cleanlinessGuardian': '50+ cleanliness ratings',
  'badges.desc.priceScout': '50+ pricing ratings',
  'badges.desc.serviceJudge': '50+ service ratings',
  'badges.desc.interiorCritic': '50+ interior ratings',

  // Badge requirements
  'badges.req.newbie': 'Submit 1 to 9 reviews',
  'badges.req.explorer': 'Submit 10 to 29 reviews',
  'badges.req.helper': 'Submit 30 to 49 reviews',
  'badges.req.trustedLocal': 'Submit 50 to 99 reviews',
  'badges.req.localExpert': 'Submit 100 to 199 reviews',
  'badges.req.cityMaster': 'Submit 200 to 299 reviews',
  'badges.req.countryMaster': 'Submit 300+ reviews',
  'badges.req.cleanlinessGuardian': 'Rate cleanliness 50+ times',
  'badges.req.priceScout': 'Rate pricing 50+ times',
  'badges.req.serviceJudge': 'Rate service 50+ times',
  'badges.req.interiorCritic': 'Rate interior 50+ times',

  'badges.title': 'Your Badges',
  'badges.allBadges': 'All Badges',
  'badges.infoSheet.title': 'How to Earn Badges',
  'badges.progress': 'Progress',
  'badges.earned': 'Earned',
  'badges.primaryBadges': 'Primary Badges',
  'badges.specialtyBadges': 'Specialty Badges',
  'badges.selectToDisplay': 'Select badge to display on reviews',
  'badges.selectToShow': 'Select to show',
  'badges.displayBadgeUpdated': 'Display badge updated',
  'badges.displayBadgeUpdatedDesc': 'Your selected badge will now appear on all your reviews',
  'badges.displayBadgeUpdateError': 'Failed to update display badge',
  'badges.stats.current': 'Current reviews -',
  'badges.stats.currentCleanliness': 'Current cleanliness ratings -',
  'badges.stats.currentPricing': 'Current pricing ratings -',
  'badges.stats.currentService': 'Current service ratings -',
  'badges.stats.currentInterior': 'Current interior ratings -',
  
  // Earned badges section
  'badges.earnedBadges': 'Earned Badges',
  
  // Auth sign out messages
  'auth.signedOutSuccess': 'Successfully signed out',
  'auth.signOutError': 'Failed to sign out. Please try again.',
  
  // Review toast messages
  'reviews.updateSuccess': 'Review updated successfully',
  'reviews.updateError': 'Failed to update review',
  'reviews.deleteSuccess': 'Review deleted successfully',
  'reviews.deleteError': 'Failed to delete review',
  'reviews.submitSuccess': 'Review submitted successfully!',
  
  // Delete confirmation dialog
  'dialog.areYouAbsolutelySure': 'Are you absolutely sure?',
  'dialog.deleteReviewWarning': 'This action cannot be undone. This will permanently delete your review.',
  'dialog.delete': 'Delete',
  'dialog.cancel': 'Cancel',
  
  // Welcome toast and profile
  'auth.signedInSuccessfully': 'Signed in successfully',
  'auth.welcome': 'Welcome',
  'auth.dismiss': 'Dismiss',
  'profile.characters': 'characters',
};
